"use client";

import { PAGE_TYPES } from "../../../constants";
import type { FC } from "react";
import { cn } from "@/lib/utils";
import ProgramCards1 from "./ProgramCards1";

/**
 * Program Cards variant 5 — blog layout.
 * Uses **Program Cards 1** (metadata + ExploreCourses1), not variant 2 cards.
 *
 * `blogRail` must always be true here: this component only mounts for the blog program-card variant.
 * Relying on `pageCategory === "blog"` breaks when `page_type` is missing/mismatched from the API,
 * which left ExploreCourses1 in marketing layout (centered title, large padding).
 *
 * Outer width cap still keys off page category / CMS preview so admin non-blog previews aren’t clipped.
 */
export const BlogProgramCards1: FC<any> = (props) => {
  const pageCategory = props?.pageCategory;
  const isBlogLayout =
    String(pageCategory ?? "").toLowerCase() === PAGE_TYPES.BLOG.toLowerCase() ||
    Boolean(props?.isCmsPreview);

  return (
    <div
      className={cn(
        "w-full min-w-0",
        isBlogLayout &&
          "max-w-full sm:max-w-[500px] md:max-w-[620px] lg:max-w-[732px] xl:max-w-[800px]",
      )}
    >
      {/** for desktop don't rail (hidden for <sm) */}
      <div className="hidden sm:block w-full">
        <ProgramCards1
          data={props.data}
          blogRail={false}
          blogCarousel
          pageCategory={pageCategory}
        />
      </div>


      {/** for mobile rail (hidden for >=sm) */}
      <div className="block sm:hidden">
        <ProgramCards1
          data={props.data}
          blogRail
          blogCarousel
          pageCategory={pageCategory}
        />
      </div>
    </div>
  );
};
